import { render, staticRenderFns } from "./RiskCheckDailySafetyLogCreate.vue?vue&type=template&id=6b73f8a5&scoped=true"
import script from "./RiskCheckDailySafetyLogCreate.vue?vue&type=script&lang=js"
export * from "./RiskCheckDailySafetyLogCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b73f8a5",
  null
  
)

export default component.exports